<template>
  <div class="reviews-filter">
    <div class="row align-justify align-middle">
      <div class="columns shrink">
        <span class="pointer" @click="openModal('showFilterModal')">
          <i class="material-icons inline-center">filter_list</i>
          <span class="show-for-large">
            {{ $t('APP.REVIEWS.FILTERS') }}
          </span>
        </span>
      </div>

      <div v-if="hasAppliedFilters" class="columns reviews__filters">
        <span
          v-for="(label, index) in filtersLabel"
          :key="index"
          class="chip chip--secondary chip--aligned-middle chip--mini"
        >
          {{ label }}
        </span>
        <ElButton
          type="text"
          icon="el-icon-delete"
          @click.native="resetFilters"
        />
      </div>
    </div>

    <ReviewsFilterModal
      v-model="showFilterModal"
      :current-filters="appliedFilters"
      @set-filters="setAppliedFilters"
    />
  </div>
</template>

<script>
import ReviewsFilterModal from '../modal/ReviewsFilterModal';
import { dateFormat } from '@/utils/date';
import modal from '@/mixins/modal';
import lang from '@/mixins/lang';

export default {
  name: 'ReviewsFilter',

  components: {
    ReviewsFilterModal,
  },

  mixins: [modal, lang],

  props: {
    appliedFilters: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      showFilterModal: false,
    };
  },

  computed: {
    hasAppliedFilters() {
      return Boolean(
        this.appliedFilters && Object.keys(this.appliedFilters).length,
      );
    },
    filtersLabel() {
      const labels = [];

      const {
        min_rate,
        max_rate,
        min_date,
        max_date,
        is_replied,
        app_version_code,
        sdk_version,
      } = this.appliedFilters;

      if (min_rate) {
        labels.push(`${min_rate} ${this.$t('ARROW')} ${max_rate}`);
      }

      if (min_date && max_date) {
        labels.push(
          `${this.translateDate(min_date, '')} ${this.$t(
            'ARROW',
          )} ${this.translateDate(max_date, '')}`,
        );
      }

      if (is_replied === 'true') {
        labels.push(this.$t('APP.REVIEWS.FILTERS.IS_REPLIED'));
      }

      if (is_replied === 'false') {
        labels.push(this.$t('APP.REVIEWS.FILTERS.IS_NOT_REPLIED'));
      }

      if (app_version_code) {
        labels.push(
          `${this.$t('APP.REVIEWS.FILTERS.APP_VERSION')}:${app_version_code}`,
        );
      }

      if (sdk_version) {
        labels.push(
          `${this.$t('APP.REVIEWS.FILTERS.ANDROID_VERSION')}:${sdk_version}`,
        );
      }

      return labels;
    },
  },

  methods: {
    translateDate(date, timeFormat = ' HH:mm') {
      let toFormat = `DD/MM/YYYY${timeFormat}`;

      if (this.lang === 'fa') {
        toFormat = `jYYYY/jMM/jDD${timeFormat}`;
      }

      return dateFormat(`YYYY/M/D${timeFormat}`)(toFormat)(date);
    },

    setAppliedFilters(filters) {
      this.$emit('set-filters', filters);
    },

    resetFilters() {
      this.$emit('reset-filters');
    },
  },
};
</script>

<style lang="scss">
.reviews-filter {
  padding: $global-padding * 1.5;
}
</style>
